import { http } from '@/services';

export default {
  createNewUser: async function(userData) {
    const { email, nome, celular } = userData;
    try {
      if (email === undefined)
        return Promise.reject(new Error('Missing required  parameter: email'));
      if (nome === undefined)
        return Promise.reject(new Error('Missing required  parameter: nome'));
      if (celular === undefined)
        return Promise.reject(
          new Error('Missing required  parameter: celular'),
        );

      return await http.post(`usuario/`, userData);
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },

  createNewUserPublic: async function(userData) {
    const { email, nome, celular, senha } = userData;
    try {
      if (email === undefined)
        return Promise.reject(new Error('Missing required  parameter: email'));
      if (nome === undefined)
        return Promise.reject(new Error('Missing required  parameter: nome'));
      if (celular === undefined)
        return Promise.reject(
          new Error('Missing required  parameter: celular'),
        );
      if (senha === undefined)
        return Promise.reject(new Error('Missing required  parameter: senha'));

      return await http.post(`usuario/registrar`, userData);
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },

  putUserData: async function(userData) {
    try {
      return await http.put(`usuario/`, userData);
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
  putUserPassword: async function(passwords) {
    const { senha, novaSenha, idUsuario } = passwords;
    try {
      if (senha === undefined)
        return Promise.reject(new Error('Missing required  parameter: senha'));
      if (novaSenha === undefined)
        return Promise.reject(
          new Error('Missing required  parameter: novaSenha'),
        );
      if (idUsuario === undefined)
        return Promise.reject(
          new Error('Missing required  parameter: idUsuario'),
        );
      return await http.put(`usuario/mudarsenha`, passwords);
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
  getUserList: async function() {
    try {
      return await http.get(`usuario/`);
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
  getUserById: async function (idUsuario){
    try {
      return await http.get(`usuario/${idUsuario}`)
    }catch (e){
      console.log(e)
      return e.response.data
    }
  },
  deleteUser: async function(idUsuario) {
    try {
      if (idUsuario === undefined)
        return Promise.reject(
          new Error('Missing required  parameter: idUsuario'),
        );
      return await http.delete(`usuario/${idUsuario}`);
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
  recoverPassword: async function(email) {
    try {
      return await http.get( `usuario/recuperar-senha`, {
        params: {
          email: email
        }
      });
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
  newPassword: async function(request) {
      return await http.put( `usuario/nova-senha`, request)
  },
};